import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = ({ className, type, ref, ...props }) => {
  return (
    <input
      type={type}
      className={cn(
        // h-10 on phones keeps the 44px touch target; h-9 above it keeps the
        // dashboard density the data screens need.
        'flex h-10 w-full rounded-md border border-input bg-card px-3 py-1 text-base text-foreground shadow-sm transition-all md:h-9 md:text-sm',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
        'placeholder:text-muted-foreground/70',
        'focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30',
        'disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-60',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
};
Input.displayName = 'Input';

export { Input };
